import React from "react";
import { recommendationsWidget } from "vikatan_recommendation_widget";
import Cookie from "universal-cookie";
import styles from "./styles.m.css";
import PropTypes from "prop-types";

const cookie = new Cookie();

class RecommendationsWidget extends React.Component {
  constructor(props) {
    super(props);
    this.storyRef = React.createRef();
  }
  componentDidMount() {
    const story = this.props.story;
    recommendationsWidget(
      {
        recommendation: "article",
        heading: "உங்களுக்கு பிடித்தவை",
        userId: cookie.get("thinmint"),
        merchantId: "130922",
        articleId: story.id
      },
      `desktop_${story.id}`,
      "gridView"
    );
  }
  render() {
    const story = this.props.story;
    return <div className={`desktop_${story.id} ${styles["base"]}`} />;
  }
}
RecommendationsWidget.propTypes = {
  story: PropTypes.shape({
    id: PropTypes.string,
    contributors: PropTypes.arrayOf(
      PropTypes.shape({
        "role-name": PropTypes.string,
        authors: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string
          })
        )
      })
    ),
    headline: PropTypes.string.isRequired,
    subheadline: PropTypes.string,
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          headline: PropTypes.string
        })
      })
    })
  })
};
export default RecommendationsWidget;
